/**
 * Everything that's saved in localstorage should have their key in this file
 */
//
export const LOCAL_STORAGE_CONSENT = 'consent';

// Login
export const LOCAL_STORAGE_LOGIN_USERNAME_KEY = 'username';
export const LOCAL_STORAGE_LOGIN_DATABASE_KEY = 'database';
export const LOCAL_STORAGE_LOGIN_SYSTEM_KEY = 'system';
export const LOCAL_STORAGE_LOGIN_REMEMBER_ME_KEY = 'rememberMe';

// Ekonomisk analys
export const EKONOMISK_ANALYS_IGNORE_ROWS_WARNING_KEY = 'ignoreRowWarning';

//BFO
export const BFO_OPEN_FROM_EKA = 'openBfofromEkA';

// Bisättningsjournal
export const BJ_LOKAL_INDEX = 'lokalIndex';
export const BJ_LOKAL_ID = 'lokalID';

// Logger
export const LOGGER_DAILY_ITEMS_LAST_RESET_KEY = 'loggerDailyItemsLastReset';
export const LOGGER_DAILY_ITEMS_COUNTER_KEY = 'loggerDailyItemsCounter';

// Fakturaattesten
export const ZOOMABLEIMAGE_CENTERED_IMAGE = 'aveny:centeredImage';

// Översikt rapporter
export const REPORT_SHOW_DOTTED_BORDERS = 'reportShowDottedBorders';

//Planering
export const BO_PLANERADE_AKTIVITETER_SETTING =
  'planerade_aktiviteter_settings';
export const BO_BOKADE_AKTIVITETER_SETTING = 'bokade_aktiviteter_settings';
export const BO_DATUM_FRAN_SETTING = 'datum_fran_settings';
export const BO_DATUM_TILL_SETTING = 'datum_till_settings';
export const BO_IS_VALID_DATE_FRAN_SETTING = 'is_valid_date_fran_setting';
export const BO_IS_VALID_DATE_TILL_SETTING = 'is_valid_date_till_setting';
export const BO_TYPE_CONDITION_SETTING = 'akttyp_setting';
export const BO_BOKNINGSRUBRIKER_SETTING = 'bokningsrubriker_setting';
